import React, {useState, useRef} from 'react';
import { Link } from 'react-router-dom';

function AuthTwoFactorMain({ handleCheckOTP, resendOTP }) {
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const inputRefs = useRef([]);

    const handleChange = (element, index) => {
        const value = element.value;
        if (isNaN(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value.substring(value.length - 1);
        setOtp(newOtp);

        if (value && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const data = e.clipboardData.getData("text").trim();
        if (data.length === 6 && !isNaN(data)) {
            setOtp(data.split(""));
            inputRefs.current[5].focus();
        }
    };

    const handleSubmit = (e, code) => {
        e.preventDefault();
        handleCheckOTP(code);
    };

    const handleResend = (e) => {
        e.preventDefault();
        resendOTP();
    };

    return (
        <>
            <main className="flex-1 flex flex-col items-center justify-center px-4 py-12 relative">
                <div className="absolute inset-0 z-0 opacity-10 pointer-events-none overflow-hidden">
                    <img className="w-full h-full object-cover" data-alt="Abstract dark racing track with motion blur" src="https://lh3.googleusercontent.com/aida-public/AB6AXuBKqQz6UAyrrEQWu4miwbFSmBOAlwzRfW8LLitvVxaVavpDtcuSlJgt-iItw2dUTQ-BYp6frvs4tu9gDOpPaQAreXd6GJRA1iqmChzNW4UD6BJPqQ3O7SNvDKyt7hfWEQ8lrf1_zImFpC4VmbH_XHzSCl4ue-huzMhh0Gz34vH__A3cZ82mfq0uyAPfEEZ2JgDPqzz98o48HYWN4Rl2nXKP74ERx4YWVaMNSem4BNfOa2iKnNSfm2O7czVGrhjBFmEyFjdmUilj2Jo" />
                </div>
                <div className="w-full max-w-[480px] z-10">
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center size-16 rounded-full bg-primary/10 mb-6 border border-primary/20">
                            <span className="material-symbols-outlined text-primary text-3xl">verified_user</span>
                        </div>
                        <h1 className="text-white tracking-tight text-[32px] font-bold leading-tight pb-2">Two-Factor Authentication</h1>
                        <p className="text-white/60 text-base font-normal leading-normal">Enter the 6-digit code sent to your email address</p>
                    </div>
                    <div className="glass-card rounded-xl p-8 shadow-2xl">
                        <form className="space-y-8">
                            <div className="flex justify-between gap-2 md:gap-4">
                                {otp.map((data, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        inputMode="numeric"
                                        maxLength="1"
                                        ref={(el) => (inputRefs.current[index] = el)}
                                        value={data}
                                        onChange={(e) => handleChange(e.target, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        onPaste={handlePaste}
                                        className="input-glow md:w-12 w-[2.5rem] h-14 md:w-14 md:h-16 text-center text-2xl font-bold rounded-lg border border-[#324d67] bg-[#192633] text-white focus:outline-0 focus:ring-2 focus:ring-primary focus:border-primary transition-all"
                                    />
                                ))}
                            </div>
                            <div className="space-y-4">
                                <button onClick={(e) => handleSubmit(e, otp.join(""))} className="w-full bg-primary hover:bg-primary/80 text-white font-bold py-4 rounded-lg shadow-lg shadow-primary/20 transition-all flex items-center justify-center gap-2 group" type="submit">
                                    Verify &amp; Continue
                                    <span className="material-symbols-outlined group-hover:translate-x-1 transition-transform">arrow_forward</span>
                                </button>
                                <div className="flex flex-col items-center gap-3 pt-2">
                                    <p className="text-white/40 text-sm">Didn't receive the code?</p>
                                    <button onClick={(e) => handleResend(e)} className="text-primary hover:text-primary/80 text-sm font-semibold underline-offset-4 hover:underline transition-all" type="button">
                                        Resend Code
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="mt-8 text-center">
                        <Link to="/login">
                            <button className="inline-flex items-center gap-2 text-white/40 hover:text-white text-sm font-medium transition-colors">
                                <span className="material-symbols-outlined text-lg">arrow_back</span>
                                Back to Login
                            </button>
                        </Link>
                    </div>
                </div>
            </main>
        </>
    );
}

export default AuthTwoFactorMain;